// extracted by mini-css-extract-plugin
module.exports = {"tableCell":"table-widget_tableCell__1JNxN","textOrange":"table-widget_textOrange__ojdzo","truncate":"table-widget_truncate__1RANu","table":"table-widget_table__3sOOH"};